import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import MapWidget from './MapWidget';
import { DEFAULT_GEO_HEATMAP, geoHeatmapConfigToMapConfig } from '../utils/geoHeatmapConfig';
import { HEATMAP_STYLE_GRADIENT } from '../utils/heatmapMatrix';

function GeoHeatmapLegend() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 0.5,
        py: 0.25,
        flexShrink: 0,
        position: 'absolute',
        bottom: 8,
        left: 8,
        right: 8,
        zIndex: 1000,
        bgcolor: 'rgba(255,255,255,0.92)',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 32 }}>
        Baja
      </Typography>
      <Box
        sx={{
          flex: 1,
          height: 10,
          borderRadius: 1,
          background: HEATMAP_STYLE_GRADIENT,
        }}
      />
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 32, textAlign: 'right' }}>
        Alta
      </Typography>
    </Box>
  );
}

/**
 * Heatmap de densidad sobre mapa OSM (lat/lng).
 * Wrapper sobre MapWidget con heatmap activo.
 */
export default function GeoHeatmapWidget({
  data = [],
  geoHeatmapConfig = {},
  getAuthHeaders,
  onConfigChange,
  showControls = false,
}) {
  const cfg = { ...DEFAULT_GEO_HEATMAP, ...geoHeatmapConfig };
  const mapConfig = useMemo(() => geoHeatmapConfigToMapConfig(cfg), [cfg]);

  const handleMapConfigChange = (patch) => {
    if (!onConfigChange) return;
    const next = { ...cfg };
    if (patch.latColumn != null) next.latColumn = patch.latColumn;
    if (patch.lngColumn != null) next.lngColumn = patch.lngColumn;
    if (patch.valueColumn != null) next.weightColumn = patch.valueColumn;
    if (patch.heatmapUseValue != null) next.heatmapUseValue = patch.heatmapUseValue;
    if (patch.heatmapRadius != null) next.heatmapRadius = patch.heatmapRadius;
    if (patch.heatmapBlur != null) next.heatmapBlur = patch.heatmapBlur;
    if (patch.popupColumns != null) next.popupColumns = patch.popupColumns;
    onConfigChange(next);
  };

  return (
    <Box sx={{ height: '100%', minHeight: 200, flex: 1, minWidth: 0, position: 'relative', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <MapWidget
          data={data}
          mapConfig={mapConfig}
          getAuthHeaders={getAuthHeaders}
          onMapConfigChange={handleMapConfigChange}
          forceHeatmapMode
          hideHeatmapToggle
          compactControls={!showControls}
        />
        {cfg.showLegend !== false && <GeoHeatmapLegend />}
      </Box>
    </Box>
  );
}
